import React from 'react';
import { observer } from 'mobx-react';
import {
    Grid,
} from '@material-ui/core';

import UserProfile from './user';
import Security from './security';
import OrganisationSettings from './account';
import Billing from './billing';
import Tabs from './tabs';
import { useUserStore } from '../../store/models';
import useUserPublisherInfo from '../../store/models/user/useUserPublisherInfo';
import useModuleErrorDialog from '../../store/models/error/useModuleErrorDialog';
import { useVisibleTabs } from './useVisibleTabs';

function Profile (props) {
    const {
        location,
    } = props;

    const userStore = useUserStore();

    const {
        user,
        publisher,
        progress,
        setProgress,
        publisherLogoEditable,
        publisherLogoError,
        uploadPublisherLogo,
        deletePublisherLogo,
        aws,
        errors,
    } = useUserPublisherInfo();

    const {
        tabs,
        tabIndex,
        updateTab,
    } = useVisibleTabs({
        isFederated: aws?.isFederated,
        location,
    });

    const {
        renderErrorDialog,
    } = useModuleErrorDialog({
        errors,
        onCloseError: () => {},
    }); 

    return (
        <React.Fragment>
            <Grid container spacing={6}>
                <Tabs
                    tabs={tabs}
                    tabIndex={tabIndex}
                    onTabChange={(newTab) => {
                        updateTab(newTab);
                    }}
                />
                <Grid item xs={12}>
                    { tabs[tabIndex]?.id === 'profile' && (
                        <UserProfile
                            user={user}
                            inProgress={progress.user}
                            publisher={publisher}
                            onSave={(data) => {
                                setProgress({
                                    ...progress,
                                    user: true,
                                });
                                userStore.updateUserProfile({ user: data });
                            }}
                        />
                    )}

                    { tabs[tabIndex]?.id === 'security' && (
                        <Security
                            isFederated={aws?.isFederated}
                            onSavePassword={(data) => {
                                userStore.changePassword({ ...data });
                            }}
                        />
                    )}

                    { tabs[tabIndex]?.id === 'org' && (
                        <OrganisationSettings
                            inProgress={progress.publisher}
                            publisher={publisher}
                            publisherLogo={publisherLogoEditable}
                            uploadPublisherLogo={uploadPublisherLogo}
                            deletePublisherLogo={deletePublisherLogo}
                            onSave={(data) => {
                                setProgress({
                                    ...progress,
                                    publisher: true,
                                });
                                userStore.updateProfile({ user: data, orgSettings: true });
                            }}
                            publisherLogoError={publisherLogoError}
                        />
                    )}

                    { tabs[tabIndex]?.id === 'billing' && (
                        <Billing
                            user={user}
                            publisher={publisher}
                            onSave={(data) => {
                                userStore.updateProfile({ user: data });
                            }}
                        />
                    )}
                </Grid>
            </Grid>
            { renderErrorDialog() }
        </React.Fragment>
    );
}

Profile.propTypes = {

};

Profile.defaultProps = {

};

export default observer(Profile);
